<app-header></app-header>
<div id="main">
    <div class="content">
        <div class="inner-page-wrapper">
            <div class="container">
                <!--<h3>Індекси</h3>-->

                <h3>{{currentPageLabel}}</h3>
<!--                <p>{{currentHelpClient}}</p>-->

               <!--  <div class="pills-wrapper nav  flex-row" [hidden]="isTabsAreHidden">
                    <a class="pill flex-sm-fill text-sm-center one left-tab " (click)="changeTab('find-address')" data-toggle="pill" routerLink="find-address" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" >Знайти адресу</a>
                    <a class="pill flex-sm-fill text-sm-center one right-tab" (click)="changeTab('find-post-index')" data-toggle="pill" routerLink="find-post-index" routerLinkActive="active" [routerLinkActiveOptions]="{exact: false}" >Знайти індекс</a>
                </div> -->

<!--                <div class="alert-message">-->
<!--                    <p>-->
<!--                      Пошук поштового індексу для доставки відправлень/ переказів на адресу Отримувача. Для доставки до відділення використовуйте, будь ласка, пошук індексу відділення на <a href="https://offices.ukrposhta.ua/">сторінці</a>.-->
<!--                    </p>-->
<!--                </div>-->

                <router-outlet></router-outlet>

            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>
<app-cookie-message></app-cookie-message>
